import { Box, Heading, Spinner, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fetchOrderStats } from "../../api";

const OrdersStatsChart = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const load = async () => {
            try {
                const res = await fetchOrderStats();
                setData(res.data || []);
            } catch (err) {
                console.error("Error loading stats", err);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, []);

    if (loading) return <Spinner mt={4} />;

    return (
        <Box p={4} borderWidth="1px" borderRadius="lg" boxShadow="md">
            <Heading size="md" mb={4}>
                Supplies Sendout Orders {new Date().getFullYear()}
            </Heading>
            {data.length === 0 ? (
                <Text>No order data available.</Text>
            ) : (
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={data}>
                        <XAxis dataKey="month" />
                        <YAxis allowDecimals={false} />
                        <Tooltip />
                        <Bar dataKey="total" name="Orders" />
                    </BarChart>
                </ResponsiveContainer>
            )}
        </Box>
    );
};

export default OrdersStatsChart;
